module.exports = __webpack_public_path__ + "img/vippack-inactive.72ac1ffa.svg";